/**Takes number and returns level1, 2, 3, 4 as a string to use for classNames */
export const getPredictionColor = (percent: number) => {
  if (percent >= 50) {
    return 'level1';
  } else if (percent > 30) {
    return 'level2';
  } else if (percent > 10) {
    return 'level3';
  }

  return 'level4';
};
